import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Navbar,
  Nav,
  Button,
  Offcanvas,
} from "react-bootstrap";
import { FaSearch, FaUserCircle, FaBars } from "react-icons/fa";
import logo from "../assets/logo3.png";
import "../styles/navbar.css";
import Cookies from "js-cookie";
import SearchModal from "./SearchModal";

const Navbar2 = () => {
  const [showIdeaModal, setShowIdeaModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const currentuser = Cookies.get("user_id");

  const toggleMenu = () => setShowMenu((prev) => !prev);

  const handleLogout = () => {
    Cookies.remove("access_token");
    Cookies.remove("user_id");
    // remove other cookies if needed
    navigate("/login");
  };

  return (
    <>
      <Navbar expand="lg" className="navbar2 shadow-sm" dir="rtl" sticky="top">
        <Container className="justify-content-between align-items-center">
          <Button variant="outline-primary" className="d-lg-none me-2" onClick={toggleMenu}>
            <FaBars />
          </Button>

          <Navbar.Brand as={Link} to="/home" className="custom-logo">
            <img src={logo} alt="Logo" style={{ height: "80px" }} />
          </Navbar.Brand>

          <Nav className="nav2-links mx-auto nav-links d-none d-lg-flex">
            <Nav.Link as={Link} to="/home">خانه</Nav.Link>
            <Nav.Link as={Link} to="/submit-idea">ثبت ایده</Nav.Link>
            <Nav.Link as={Link} to="#">تماس با ما</Nav.Link>
            <Nav.Link onClick={handleLogout} style={{ cursor: "pointer" }}>خروج</Nav.Link>
          </Nav>

          <div className="d-flex align-items-center gap-2">
            <SearchModal />
            <Button className="profile-btn" as={Link} to={`/dashboard/`}>
              <FaUserCircle />
            </Button>
          </div>
        </Container>
      </Navbar>

      <Offcanvas show={showMenu} onHide={toggleMenu} placement="end" dir="rtl">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>منو</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column gap-3 text-end">
            <Nav.Link as={Link} to="/home" onClick={toggleMenu}>خانه</Nav.Link>
            <Nav.Link as={Link} to="/submit-idea" onClick={toggleMenu}>ثبت ایده</Nav.Link>
            <Nav.Link as={Link} to="#" onClick={toggleMenu}>تماس با ما</Nav.Link>
            <Nav.Link onClick={() => { toggleMenu(); handleLogout(); }} style={{ cursor: "pointer" }}>
              خروج
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Navbar2;
